"use strict";

var objToString = Object.prototype.toString
  , id = objToString.call((function () { return arguments; })());

module.exports = function (value) { return objToString.call(value) === id; };



//////////////////
// WEBPACK FOOTER
// ./node_modules/es5-ext/function/is-arguments.js
// module id = 220
// module chunks = 0